<template>
    <aside class="catalog-layout__sidebar">
        <button class="not-big catalog-layout__sidebar_trigger" id="showHideFilters"><span>Фильтры<span class="count" v-if="Object.keys($parent.formatedFilters).length > 0">{{Object.keys($parent.formatedFilters).length}}</span></span></button>
        <div class="catalog-layout__sidebar_container">
            <div class="catalog-layout__sidebar_content">
                <form class="form-default white-fields" @submit.prevent="submit" @reset.prevent="reset">
                    <div class="row">
                        <div class="group-title"><span>количество комнат</span></div>
                        <room-numbers-list v-model="filters.roomTypes"></room-numbers-list>
                    </div>

                    <!-- Price -->
                    <div class="row">
                        <div class="group-title"><span>Стоимость</span></div>
                        <label class="input-container">
                            <span class="input-container__prefix">от</span>
                            <span class="input-container__postfix"><i class="ruble"></i></span>
                            <input type="number" placeholder="1 000 000" v-model.number="filters.price.minimum">
                        </label>
                    </div>
                    <div class="row">
                        <label class="input-container">
                            <span class="input-container__prefix">до</span>
                            <span class="input-container__postfix"><i class="ruble"></i></span>
                            <input type="number" placeholder="20 000 000" v-model.number="filters.price.maximum">
                        </label>
                    </div>

                    <!-- Readinesses -->
                    <div class="row m-2">
                        <div class="group-title"><span>Срок сдачи до</span></div>
                        <ending-years-list v-model="filters.readinesses"></ending-years-list>
                    </div>

                    <!-- Square - Total -->
                    <div class="row m-va-t">
                        <div class="group-title"><span>Общая площадь</span></div>
                        <div class="col">
                            <label class="input-container">
                                <span class="input-container__prefix">от</span>
                                <span class="input-container__postfix">м<sup>2</sup></span>
                                <input type="number" placeholder="34" v-model.number="filters.square.minimum">
                            </label>
                        </div>
                        <div class="col">
                            <label class="input-container">
                                <span class="input-container__prefix">до</span>
                                <span class="input-container__postfix">м<sup>2</sup></span>
                                <input type="number" placeholder="60" v-model.number="filters.square.maximum">
                            </label> 
                        </div>
                    </div>

                    <!-- Square - Kitchen -->
                    <div class="row">
                        <div class="group-title"><span>Площадь кухни</span></div>
                        <div class="col">
                            <label class="input-container">
                                <span class="input-container__prefix">от</span>
                                <span class="input-container__postfix">м<sup>2</sup></span>
                                <input type="number" placeholder="10" v-model.number="filters.squareKitchen.minimum">
                            </label>
                        </div>
                        <div class="col">
                            <label class="input-container">
                                <span class="input-container__prefix">до</span>
                                <span class="input-container__postfix">м<sup>2</sup></span>
                                <input type="number" placeholder="15" v-model.number="filters.squareKitchen.maximum">
                            </label>
                        </div>
                    </div>

                    <!-- Floor -->
                    <div class="row">
                        <div class="group-title"><span>Этаж</span></div>
                        <div class="col">
                            <label class="input-container">
                                <span class="input-container__prefix">от</span>
                                <input type="number" placeholder="1" v-model.number="filters.floor.minimum">
                            </label>
                        </div>
                        <div class="col">
                            <label class="input-container">
                                <span class="input-container__prefix">до</span>
                                <input type="number" placeholder="25" v-model.number="filters.floor.maximum">
                            </label>
                        </div>
                    </div>

                    <!-- Facing -->
                    <div class="row">
                        <div class="group-title"><span>Отделка</span></div>
                        <facing-dropdown v-model="filters.facing"></facing-dropdown>                        
                    </div>

                    <button class="button-pill filled" type="submit" @click.prevent="submit">Поиск</button>
                    <button class="button-pill lighted" type="reset" @click.prevent="reset"><i class="cross"></i>Сбросить фильтры</button>
                </form>
            </div>
        </div>
    </aside>
</template>

<script>
    // Vue
    import roomNumbersList from './RoomNumbersList.vue';
    import roomsCount from '../filters/roomsCount'
    import endingYearsList from './EndingYearsList.vue';
    import facingDropdown from './FacingDropdown.vue';

    export default {
        props: {
            filters: {
                type: Object,
                required: true
            }
        },
        methods: {
            submit() {
                this.$emit('submited');
                this.toggleMenu();
            },
            reset() {
                this.$emit('reset');
                this.toggleMenu();
            },
            toggleMenu() {
                let btn = document.getElementById('showHideFilters');
                btn.click();
            }
        },
        components: {
            roomNumbersList,
            roomsCount,
            endingYearsList,
            facingDropdown
        }
    }
</script>